// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.2.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #EEEEEE; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, Inter var, Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #BDBDBD; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 600px) {

  .container {
    max-width: 600px;
  }
}
@media (min-width: 960px) {

  .container {
    max-width: 960px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1920px) {

  .container {
    max-width: 1920px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.left-0 {
  left: 0px;
}
.-top-64 {
  top: -6.4rem;
}
.-right-64 {
  right: -6.4rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-\\[22px\\] {
  top: 22px;
}
.right-\\[28px\\] {
  right: 28px;
}
.right-3 {
  right: 0.3rem;
}
.right-32 {
  right: 3.2rem;
}
.top-24 {
  top: 2.4rem;
}
.-right-12 {
  right: -1.2rem;
}
.-top-16 {
  top: -1.6rem;
}
.z-99 {
  z-index: 99;
}
.z-9999 {
  z-index: 9999;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.z-20 {
  z-index: 20;
}
.z-999 {
  z-index: 999;
}
.order-first {
  order: -9999;
}
.order-last {
  order: 9999;
}
.m-8 {
  margin: 0.8rem;
}
.m-32 {
  margin: 3.2rem;
}
.m-auto {
  margin: auto;
}
.m-0 {
  margin: 0px;
}
.m-24 {
  margin: 2.4rem;
}
.m-5 {
  margin: 0.5rem;
}
.m-16 {
  margin: 1.6rem;
}
.m-4 {
  margin: 0.4rem;
}
.m-1 {
  margin: 0.1rem;
}
.m-3 {
  margin: 0.3rem;
}
.mx-8 {
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}
.my-16 {
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}
.my-8 {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
}
.-mx-8 {
  margin-left: -0.8rem;
  margin-right: -0.8rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-24 {
  margin-left: 2.4rem;
  margin-right: 2.4rem;
}
.my-4 {
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
}
.mx-16 {
  margin-left: 1.6rem;
  margin-right: 1.6rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.my-24 {
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
}
.my-256 {
  margin-top: 25.6rem;
  margin-bottom: 25.6rem;
}
.mx-4 {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.mx-32 {
  margin-left: 3.2rem;
  margin-right: 3.2rem;
}
.mx-6 {
  margin-left: 0.6rem;
  margin-right: 0.6rem;
}
.my-48 {
  margin-top: 4.8rem;
  margin-bottom: 4.8rem;
}
.-mx-12 {
  margin-left: -1.2rem;
  margin-right: -1.2rem;
}
.my-64 {
  margin-top: 6.4rem;
  margin-bottom: 6.4rem;
}
.mx-64 {
  margin-left: 6.4rem;
  margin-right: 6.4rem;
}
.-mx-4 {
  margin-left: -0.4rem;
  margin-right: -0.4rem;
}
.-mx-16 {
  margin-left: -1.6rem;
  margin-right: -1.6rem;
}
.mb-52 {
  margin-bottom: 5.2rem;
}
.mr-8 {
  margin-right: 0.8rem;
}
.mb-4 {
  margin-bottom: 0.4rem;
}
.-mb-16 {
  margin-bottom: -1.6rem;
}
.mt-0 {
  margin-top: 0px;
}
.mb-24 {
  margin-bottom: 2.4rem;
}
.ml-8 {
  margin-left: 0.8rem;
}
.mb-8 {
  margin-bottom: 0.8rem;
}
.-mb-10 {
  margin-bottom: -1.0rem;
}
.mr-4 {
  margin-right: 0.4rem;
}
.-mt-24 {
  margin-top: -2.4rem;
}
.mt-12 {
  margin-top: 1.2rem;
}
.mt-32 {
  margin-top: 3.2rem;
}
.mt-10 {
  margin-top: 1.0rem;
}
.mt-6 {
  margin-top: 0.6rem;
}
.ml-4 {
  margin-left: 0.4rem;
}
.mt-24 {
  margin-top: 2.4rem;
}
.mt-16 {
  margin-top: 1.6rem;
}
.mt-4 {
  margin-top: 0.4rem;
}
.mt-2 {
  margin-top: 0.2rem;
}
.mr-20 {
  margin-right: 2rem;
}
.-mt-8 {
  margin-top: -0.8rem;
}
.mt-8 {
  margin-top: 0.8rem;
}
.mt-48 {
  margin-top: 4.8rem;
}
.mb-16 {
  margin-bottom: 1.6rem;
}
.mt-1 {
  margin-top: 0.1rem;
}
.mb-12 {
  margin-bottom: 1.2rem;
}
.ml-16 {
  margin-left: 1.6rem;
}
.mt-36 {
  margin-top: 3.6rem;
}
.ml-32 {
  margin-left: 3.2rem;
}
.mr-2 {
  margin-right: 0.2rem;
}
.mb-3 {
  margin-bottom: 0.3rem;
}
.mr-3 {
  margin-right: 0.3rem;
}
.-mt-1 {
  margin-top: -0.1rem;
}
.mr-16 {
  margin-right: 1.6rem;
}
.mr-32 {
  margin-right: 3.2rem;
}
.ml-14 {
  margin-left: 1.4rem;
}
.ml-2 {
  margin-left: 0.2rem;
}
.mb-2 {
  margin-bottom: 0.2rem;
}
.mb-6 {
  margin-bottom: 0.6rem;
}
.mb-1 {
  margin-bottom: 0.1rem;
}
.mt-14 {
  margin-top: 1.4rem;
}
.mb-10 {
  margin-bottom: 1.0rem;
}
.mb-32 {
  margin-bottom: 3.2rem;
}
.ml-24 {
  margin-left: 2.4rem;
}
.mr-12 {
  margin-right: 1.2rem;
}
.-mt-48 {
  margin-top: -4.8rem;
}
.mt-96 {
  margin-top: 9.6rem;
}
.mt-52 {
  margin-top: 5.2rem;
}
.mr-24 {
  margin-right: 2.4rem;
}
.ml-10 {
  margin-left: 1.0rem;
}
.mt-20 {
  margin-top: 2rem;
}
.mr-10 {
  margin-right: 1.0rem;
}
.ml-5 {
  margin-left: 0.5rem;
}
.ml-64 {
  margin-left: 6.4rem;
}
.mt-64 {
  margin-top: 6.4rem;
}
.mt-\\[-20px\\] {
  margin-top: -20px;
}
.ml-20 {
  margin-left: 2rem;
}
.\\!mt-2 {
  margin-top: 0.2rem !important;
}
.mb-20 {
  margin-bottom: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.-ml-8 {
  margin-left: -0.8rem;
}
.mt-5 {
  margin-top: 0.5rem;
}
.mb-5 {
  margin-bottom: 0.5rem;
}
.ml-6 {
  margin-left: 0.6rem;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mb-48 {
  margin-bottom: 4.8rem;
}
.-mt-32 {
  margin-top: -3.2rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-12 {
  margin-left: 1.2rem;
}
.mr-64 {
  margin-right: 6.4rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!inline {
  display: inline !important;
}
.flex {
  display: flex;
}
.\\!flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-full {
  height: 100%;
}
.h-40 {
  height: 4rem;
}
.h-48 {
  height: 4.8rem;
}
.h-8 {
  height: 0.8rem;
}
.h-56 {
  height: 5.6rem;
}
.h-20 {
  height: 2rem;
}
.h-96 {
  height: 9.6rem;
}
.h-24 {
  height: 2.4rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-16 {
  height: 1.6rem;
}
.h-1 {
  height: 0.1rem;
}
.h-6 {
  height: 0.6rem;
}
.h-36 {
  height: 3.6rem;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-fit {
  height: fit-content;
}
.h-32 {
  height: 3.2rem;
}
.h-4 {
  height: 0.4rem;
}
.h-\\[420px\\] {
  height: 420px;
}
.h-80 {
  height: 8rem;
}
.h-12 {
  height: 1.2rem;
}
.h-screen {
  height: 100vh;
}
.h-28 {
  height: 2.8rem;
}
.h-60 {
  height: 6rem;
}
.h-10 {
  height: 1.0rem;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-7 {
  height: 0.7rem;
}
.h-3\\/5 {
  height: 60%;
}
.h-\\[95\\%\\] {
  height: 95%;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-128 {
  height: 12.8rem;
}
.max-h-32 {
  max-height: 3.2rem;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-48 {
  max-height: 4.8rem;
}
.max-h-screen {
  max-height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-full {
  max-height: 100%;
}
.min-h-full {
  min-height: 100%;
}
.min-h-32 {
  min-height: 3.2rem;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-40 {
  min-height: 4rem;
}
.min-h-48 {
  min-height: 4.8rem;
}
.min-h-1 {
  min-height: 0.1rem;
}
.w-full {
  width: 100%;
}
.w-48 {
  width: 4.8rem;
}
.w-24 {
  width: 2.4rem;
}
.w-40 {
  width: 4rem;
}
.w-1\\/4 {
  width: 25%;
}
.w-128 {
  width: 12.8rem;
}
.w-20 {
  width: 2rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-28 {
  width: 2.8rem;
}
.w-3\\/4 {
  width: 75%;
}
.\\!w-full {
  width: 100% !important;
}
.w-16 {
  width: 1.6rem;
}
.w-56 {
  width: 5.6rem;
}
.w-6 {
  width: 0.6rem;
}
.w-36 {
  width: 3.6rem;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-fit {
  width: fit-content;
}
.w-32 {
  width: 3.2rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-4 {
  width: 0.4rem;
}
.w-320 {
  width: 32rem;
}
.w-64 {
  width: 6.4rem;
}
.w-96 {
  width: 9.6rem;
}
.w-200 {
  width: 20rem;
}
.w-400 {
  width: 40rem;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-60 {
  width: 6rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-10 {
  width: 1.0rem;
}
.w-\\[53\\%\\] {
  width: 53%;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-256 {
  width: 25.6rem;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-1\\/5 {
  width: 20%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-7 {
  width: 0.7rem;
}
.w-8 {
  width: 0.8rem;
}
.w-auto {
  width: auto;
}
.min-w-64 {
  min-width: 6.4rem;
}
.min-w-40 {
  min-width: 4rem;
}
.min-w-256 {
  min-width: 25.6rem;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-480 {
  min-width: 48rem;
}
.min-w-16 {
  min-width: 1.6rem;
}
.min-w-20 {
  min-width: 2rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-72 {
  min-width: 7.2rem;
}
.min-w-max {
  min-width: max-content;
}
.min-w-128 {
  min-width: 12.8rem;
}
.min-w-24 {
  min-width: 2.4rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-320 {
  max-width: 32rem;
}
.max-w-2xl {
  max-width: 65.6rem;
}
.max-w-4xl {
  max-width: 89.6rem;
}
.max-w-360 {
  max-width: 36rem;
}
.max-w-480 {
  max-width: 48rem;
}
.max-w-\\[92\\%\\] {
  max-width: 92%;
}
.max-w-md {
  max-width: 64rem;
}
.max-w-48 {
  max-width: 4.8rem;
}
.max-w-xs {
  max-width: 32rem;
}
.max-w-\\[calc\\(100\\%-5rem\\)\\] {
  max-width: calc(100% - 5rem);
}
.max-w-200 {
  max-width: 20rem;
}
.max-w-screen-sm {
  max-width: 600px;
}
.max-w-3xl {
  max-width: 76.8rem;
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-7xl {
  max-width: 128rem;
}
.max-w-lg {
  max-width: 80rem;
}
.max-w-192 {
  max-width: 19.2rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.grow {
  flex-grow: 1;
}
.table-fixed {
  table-layout: fixed;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-100\\%\\] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
@keyframes shine {

  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
.animate-shine {
  animation: shine 2s infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-default {
  cursor: default;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.appearance-none {
  appearance: none;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-center {
  place-content: center;
}
.place-content-start {
  place-content: start;
}
.place-content-end {
  place-content: end;
}
.\\!place-content-between {
  place-content: space-between !important;
}
.place-content-between {
  place-content: space-between;
}
.place-content-evenly {
  place-content: space-evenly;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-4 {
  gap: 0.4rem;
}
.gap-16 {
  gap: 1.6rem;
}
.gap-8 {
  gap: 0.8rem;
}
.gap-20 {
  gap: 2rem;
}
.gap-32 {
  gap: 3.2rem;
}
.gap-24 {
  gap: 2.4rem;
}
.gap-10 {
  gap: 1.0rem;
}
.gap-12 {
  gap: 1.2rem;
}
.gap-6 {
  gap: 0.6rem;
}
.gap-y-16 {
  row-gap: 1.6rem;
}
.gap-x-8 {
  column-gap: 0.8rem;
}
.gap-y-32 {
  row-gap: 3.2rem;
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.8rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.8rem * var(--tw-space-y-reverse));
}
.space-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.2rem * var(--tw-space-y-reverse));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.4rem * var(--tw-space-x-reverse));
  margin-left: calc(0.4rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.3rem * var(--tw-space-x-reverse));
  margin-left: calc(0.3rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.2rem * var(--tw-space-x-reverse));
  margin-left: calc(0.2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.1rem * var(--tw-space-y-reverse));
}
.space-y-32 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3.2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3.2rem * var(--tw-space-y-reverse));
}
.space-x-16 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.6rem * var(--tw-space-x-reverse));
  margin-left: calc(1.6rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.6rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.6rem * var(--tw-space-y-reverse));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-x-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.2rem * var(--tw-space-x-reverse));
  margin-left: calc(1.2rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.2rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.4rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.4rem * var(--tw-space-y-reverse));
}
.divide-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.justify-self-center {
  justify-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.\\!whitespace-normal {
  white-space: normal !important;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: .4rem;
}
.rounded-6 {
  border-radius: .6rem;
}
.rounded-8 {
  border-radius: .8rem;
}
.rounded-lg {
  border-radius: .8rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-4 {
  border-radius: .4rem;
}
.rounded-md {
  border-radius: .6rem;
}
.rounded-0 {
  border-radius: 0px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-sm {
  border-radius: .2rem;
}
.rounded-3xl {
  border-radius: 2.4rem;
}
.rounded-2xl {
  border-radius: 1.6rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 1.2rem;
}
.rounded-\\[36px\\] {
  border-radius: 36px;
}
.rounded-12 {
  border-radius: 1.2rem;
}
.rounded-t-16 {
  border-top-left-radius: 1.6rem;
  border-top-right-radius: 1.6rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-1 {
  border-width: 1px;
}
.border-b-1 {
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t-1 {
  border-top-width: 1px;
}
.border-r-1 {
  border-right-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(189 189 189 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(34 41 47 / var(--tw-border-opacity));
}
.border-\\[\\#473c4d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(71 60 77 / var(--tw-border-opacity));
}
.border-\\[\\#D9D9D9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}
.\\!border-gray-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(189 189 189 / var(--tw-border-opacity)) !important;
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.border-light-border-color {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-base-purple {
  --tw-border-opacity: 1;
  border-color: rgb(124 83 254 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-border-opacity));
}
.border-grey-300 {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.border-\\[\\#7C53FE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(124 83 254 / var(--tw-border-opacity));
}
.border-\\[\\#E4E7EC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 231 236 / var(--tw-border-opacity));
}
.border-green {
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(97 97 97 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-\\[\\#7F56D9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(127 86 217 / var(--tw-border-opacity));
}
.border-\\[\\#E6E6E6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 230 230 / var(--tw-border-opacity));
}
.border-\\[\\#D6C8FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 200 255 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.bg-\\[\\#D32F2F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(211 47 47 / var(--tw-bg-opacity));
}
.bg-\\[\\#F57C00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 124 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#FBC02D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 192 45 / var(--tw-bg-opacity));
}
.bg-\\[\\#1976D2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 118 210 / var(--tw-bg-opacity));
}
.bg-base-purple {
  --tw-bg-opacity: 1;
  background-color: rgb(124 83 254 / var(--tw-bg-opacity));
}
.bg-\\[\\#281463\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 20 99 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(127 86 217 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8F7FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 247 255 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 157 / var(--tw-bg-opacity));
}
.bg-\\[\\#0C051F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 5 31 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-light-bg-color {
  --tw-bg-opacity: 1;
  background-color: rgb(246 243 255 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(34 41 47 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-\\[\\#ffd6e1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 214 225 / var(--tw-bg-opacity));
}
.bg-\\[\\#C1E1C1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(193 225 193 / var(--tw-bg-opacity));
}
.bg-grey-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.bg-grey-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#E4E7EC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 231 236 / var(--tw-bg-opacity));
}
.bg-red {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#EBEFF9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 239 249 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(200 230 201 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 205 210 / var(--tw-bg-opacity));
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 196 / var(--tw-bg-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 222 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#00C68140\\] {
  background-color: #00C68140;
}
.bg-\\[\\#F0F0FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 254 / var(--tw-bg-opacity));
}
.bg-\\[\\#140c1b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 12 27 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.bg-grey-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-base-purple\\/10 {
  background-color: rgb(124 83 254 / 0.1);
}
.bg-\\[\\#7C53FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(124 83 254 / var(--tw-bg-opacity));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(178 223 219 / var(--tw-bg-opacity));
}
.bg-green {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-\\[\\#f6f8fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#EDE7FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 231 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#DBFF76\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(219 255 118 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF9575\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 149 117 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9F9F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9FBFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 251 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#faf9fb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#f8f6f9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 246 249 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f8fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 250 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFF9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 249 / var(--tw-bg-opacity));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 136 229 / var(--tw-bg-opacity));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(227 242 253 / var(--tw-bg-opacity));
}
.bg-grey-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-\\[\\#56ae57\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(86 174 87 / var(--tw-bg-opacity));
}
.bg-\\[\\#b19cd9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(177 156 217 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-base-purple {
  --tw-gradient-from: #7C53FE;
  --tw-gradient-to: rgb(124 83 254 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent;
  --tw-gradient-to: rgb(0 0 0 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400 {
  --tw-gradient-from: #EF5350;
  --tw-gradient-to: rgb(239 83 80 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#A89EF2\\] {
  --tw-gradient-from: #A89EF2;
  --tw-gradient-to: rgb(168 158 242 / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-secondary-color {
  --tw-gradient-to: #1B97CB;
}
.to-white {
  --tw-gradient-to: #fff;
}
.to-base-purple {
  --tw-gradient-to: #7C53FE;
}
.to-\\[\\#7C53FE\\] {
  --tw-gradient-to: #7C53FE;
}
.bg-clip-text {
  background-clip: text;
}
.fill-current {
  fill: currentColor;
}
.fill-base-purple {
  fill: #7C53FE;
}
.fill-black {
  fill: #22292F;
}
.stroke-1 {
  stroke-width: 1;
}
.object-contain {
  object-fit: contain;
}
.p-24 {
  padding: 2.4rem;
}
.p-12 {
  padding: 1.2rem;
}
.p-0 {
  padding: 0px;
}
.p-16 {
  padding: 1.6rem;
}
.p-8 {
  padding: 0.8rem;
}
.p-32 {
  padding: 3.2rem;
}
.p-4 {
  padding: 0.4rem;
}
.p-64 {
  padding: 6.4rem;
}
.p-2 {
  padding: 0.2rem;
}
.p-0\\.5 {
  padding: 0.05rem;
}
.p-3 {
  padding: 0.3rem;
}
.p-6 {
  padding: 0.6rem;
}
.p-10 {
  padding: 1.0rem;
}
.p-48 {
  padding: 4.8rem;
}
.p-20 {
  padding: 2rem;
}
.p-5 {
  padding: 0.5rem;
}
.py-16 {
  padding-top: 1.6rem;
  padding-bottom: 1.6rem;
}
.px-12 {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.px-16 {
  padding-left: 1.6rem;
  padding-right: 1.6rem;
}
.py-12 {
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
}
.px-8 {
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}
.py-8 {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}
.py-32 {
  padding-top: 3.2rem;
  padding-bottom: 3.2rem;
}
.py-2 {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}
.px-4 {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
.py-4 {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.px-32 {
  padding-left: 3.2rem;
  padding-right: 3.2rem;
}
.px-64 {
  padding-left: 6.4rem;
  padding-right: 6.4rem;
}
.px-6 {
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}
.px-10 {
  padding-left: 1.0rem;
  padding-right: 1.0rem;
}
.py-1 {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
.px-2 {
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}
.px-2\\.5 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.py-3 {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
.py-96 {
  padding-top: 9.6rem;
  padding-bottom: 9.6rem;
}
.px-24 {
  padding-left: 2.4rem;
  padding-right: 2.4rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.py-10 {
  padding-top: 1.0rem;
  padding-bottom: 1.0rem;
}
.py-2\\.5 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.px-5 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-28 {
  padding-left: 2.8rem;
  padding-right: 2.8rem;
}
.px-20 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-6 {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.py-20 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-24 {
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;
}
.pl-24 {
  padding-left: 2.4rem;
}
.pl-40 {
  padding-left: 4rem;
}
.pl-56 {
  padding-left: 5.6rem;
}
.pl-72 {
  padding-left: 7.2rem;
}
.pl-80 {
  padding-left: 8rem;
}
.pb-12 {
  padding-bottom: 1.2rem;
}
.pb-16 {
  padding-bottom: 1.6rem;
}
.pt-8 {
  padding-top: 0.8rem;
}
.pb-8 {
  padding-bottom: 0.8rem;
}
.pl-8 {
  padding-left: 0.8rem;
}
.pr-28 {
  padding-right: 2.8rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pl-120 {
  padding-left: 12rem;
}
.pl-16 {
  padding-left: 1.6rem;
}
.pb-14 {
  padding-bottom: 1.4rem;
}
.pt-12 {
  padding-top: 1.2rem;
}
.pr-6 {
  padding-right: 0.6rem;
}
.pr-16 {
  padding-right: 1.6rem;
}
.pr-8 {
  padding-right: 0.8rem;
}
.pb-24 {
  padding-bottom: 2.4rem;
}
.pr-10 {
  padding-right: 1.0rem;
}
.pl-4 {
  padding-left: 0.4rem;
}
.pl-20 {
  padding-left: 2rem;
}
.pb-\\[120px\\] {
  padding-bottom: 120px;
}
.pt-4 {
  padding-top: 0.4rem;
}
.pt-2 {
  padding-top: 0.2rem;
}
.pt-20 {
  padding-top: 2rem;
}
.pr-4 {
  padding-right: 0.4rem;
}
.pt-10 {
  padding-top: 1.0rem;
}
.pb-20 {
  padding-bottom: 2rem;
}
.pr-12 {
  padding-right: 1.2rem;
}
.pr-36 {
  padding-right: 3.6rem;
}
.pb-10 {
  padding-bottom: 1.0rem;
}
.pl-10 {
  padding-left: 1.0rem;
}
.pt-5 {
  padding-top: 0.5rem;
}
.pb-6 {
  padding-bottom: 0.6rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.font-inter {
  font-family: "Inter var", Inter;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-13 {
  font-size: 1.3rem;
}
.text-20 {
  font-size: 2rem;
}
.text-14 {
  font-size: 1.4rem;
}
.text-12 {
  font-size: 1.2rem;
}
.text-4xl {
  font-size: 3.2rem;
}
.text-10 {
  font-size: 1rem;
}
.text-xl {
  font-size: 1.8rem;
}
.text-base {
  font-size: 1.4rem;
}
.text-3xl {
  font-size: 2.4rem;
}
.text-6xl {
  font-size: 4rem;
}
.text-lg {
  font-size: 1.6rem;
}
.text-2xl {
  font-size: 2rem;
}
.text-sm {
  font-size: 1.2rem;
}
.text-xs {
  font-size: 1rem;
}
.text-md {
  font-size: 1.3rem;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-16 {
  font-size: 1.6rem;
}
.text-32 {
  font-size: 3.2rem;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-48 {
  font-size: 4.8rem;
}
.text-5xl {
  font-size: 3.6rem;
}
.text-11 {
  font-size: 1.1rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-15 {
  font-size: 1.5rem;
}
.font-semibold {
  font-weight: 600;
}
.font-medium {
  font-weight: 500;
}
.font-500 {
  font-weight: 500;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-tight {
  line-height: 1.25;
}
.leading-none {
  line-height: 1;
}
.leading-6 {
  line-height: 2.4rem;
}
.leading-8 {
  line-height: 3.2rem;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.text-base-purple {
  --tw-text-opacity: 1;
  color: rgb(124 83 254 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-lightGrey {
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.text-grey-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(34 41 47 / var(--tw-text-opacity));
}
.\\!text-base-purple {
  --tw-text-opacity: 1 !important;
  color: rgb(124 83 254 / var(--tw-text-opacity)) !important;
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-grey-400 {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.text-grey-800 {
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-body-text-color {
  --tw-text-opacity: 1;
  color: rgb(30 34 39 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(238 238 238 / var(--tw-text-opacity));
}
.text-\\[\\#7C53FE\\] {
  --tw-text-opacity: 1;
  color: rgb(124 83 254 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.text-light-text {
  --tw-text-opacity: 1;
  color: rgb(120 122 123 / var(--tw-text-opacity));
}
.text-\\[\\#00C681\\] {
  --tw-text-opacity: 1;
  color: rgb(0 198 129 / var(--tw-text-opacity));
}
.text-\\[\\#667085\\] {
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(57 73 171 / var(--tw-text-opacity));
}
.text-\\[\\#6200ea\\] {
  --tw-text-opacity: 1;
  color: rgb(98 0 234 / var(--tw-text-opacity));
}
.text-grey-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity));
}
.text-red {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(67 160 71 / var(--tw-text-opacity));
}
.text-grey {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(0 137 123 / var(--tw-text-opacity));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(253 216 53 / var(--tw-text-opacity));
}
.text-grey-600 {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-green {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.text-\\[\\#269CDB\\] {
  --tw-text-opacity: 1;
  color: rgb(38 156 219 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-gray {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-title-text-color {
  --tw-text-opacity: 1;
  color: rgb(71 60 77 / var(--tw-text-opacity));
}
.text-\\[\\#4D4D4D\\] {
  --tw-text-opacity: 1;
  color: rgb(77 77 77 / var(--tw-text-opacity));
}
.text-grey-900 {
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-\\[\\#060708\\] {
  --tw-text-opacity: 1;
  color: rgb(6 7 8 / var(--tw-text-opacity));
}
.text-\\[\\#424242\\] {
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-\\[\\#656c84\\] {
  --tw-text-opacity: 1;
  color: rgb(101 108 132 / var(--tw-text-opacity));
}
.text-\\[\\#7F56D9\\] {
  --tw-text-opacity: 1;
  color: rgb(127 86 217 / var(--tw-text-opacity));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(255 183 77 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-1 {
  --tw-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0px 2px 1px -1px var(--tw-shadow-color), 0px 1px 1px 0px var(--tw-shadow-color), 0px 1px 3px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-0 {
  --tw-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0px 0px 0px 0px var(--tw-shadow-color), 0px 0px 0px 0px var(--tw-shadow-color), 0px 0px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: inset 0 0 0 1px rgba(0,0,0,0.08);
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-base-purple {
  --tw-shadow-color: #7C53FE;
  --tw-shadow: var(--tw-shadow-colored);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 150 243 / var(--tw-ring-opacity));
}
.ring-gray-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 245 245 / var(--tw-ring-opacity));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

/* Force Inter + Helvetica font everywhere */
html, body, * {
  font-family: "Inter", Helvetica, Arial, sans-serif !important;
}

/**
 * Custom base styles
 */

* {
  /* Text rendering */
  text-rendering: optimizeLegibility;
  -o-text-rendering: optimizeLegibility;
  -ms-text-rendering: optimizeLegibility;
  -moz-text-rendering: optimizeLegibility;
  -webkit-text-rendering: optimizeLegibility;
  -webkit-tap-highlight-color: transparent;
}

* :focus {
  outline: none !important;
}



html {
  font-size: 62.5%;
  font-family: "Inter var";
  background-color: #121212;
}

body {
  font-size: 14px;
  line-height: 1.4;
  overflow-x: hidden;
  font-feature-settings: "salt";
  font-family: "Inter var";
}

.logo-heading {
  font-size: 18px;
  margin-left: 10px;
  font-weight: 600;
  background: -webkit-linear-gradient(
    168.48deg,
    #713ac3 -2.01%,
    #1aa4cf 104.47%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
html,
body {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0;
  min-height: 100%;
  width: 100%;
  flex: 1 1 auto;
}

.FusePageSimple-contentWrapper {
  background-color: white; /* Body content change */
}

#root {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
}

h1,
.h1 {
  font-size: 24px;
}

h2,
.h2 {
  font-size: 20px;
}

h3,
.h3 {
  font-size: 16px;
}

h4,
.h4 {
  font-size: 15px;
}

h5,
.h5 {
  font-size: 13px;
}

h6,
.h6 {
  font-size: 12px;
}

.ps > .ps__rail-y,
.ps > .ps__rail-x {
  z-index: 99;
}

a[role="button"] {
  text-decoration: none;
}

[role="tooltip"] {
  z-index: 9999;
}

.MuiModal-root {
  z-index: 9999;
}

/* Medium Devices, Desktops Only */
@media only screen and (min-width: 992px) {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar:hover {
    width: 8px;
    height: 8px;
    background-color: rgba(0, 0, 0, 0.06);
  }

  ::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    border-radius: 20px;
  }

  ::-webkit-scrollbar-thumb:active {
    border-radius: 20px;
  }
}

form label {
  z-index: 99;
}

body.no-animate *,
body.no-animate *::before,
body.no-animate *::after {
  transition: none !important;
  animation: none !important;
}

button:focus {
  outline: none;
}

/* Removes webkit's autofill backgorund color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transitiondelay: 9999s;
  transitionproperty: background-color, color;
}

:focus {
  outline-color: transparent;
}

/*fullcalendar Fix*/
.fc-scrollgrid-section-liquid {
  height: 1px !important;
}

.widget-title {
  font-size: 22px !important;
  font-weight: "medium";
  color: #242810;
}

.widget-label-tiny {
  font-size: 10px;
  font-weight: "medium";
  color: #667085;
}

.widget-label-small {
  font-size: 12px;
  font-weight: "regular";
  color: #667085;
}

.widget-label-regular {
  font-size: 14px;
  font-weight: "regular";
  color: #667085;
}

.widget-label-large {
  font-size: 20px;
  font-weight: 500 !important;
  color: #101828;
}

.widget-label-medium {
  font-size: 18px;
  font-weight: 500 !important;
  color: #101828;
}

.page-heading {
  font-size: 24px;
  font-weight: "medium";
  color: #101828;
}

.page-background {
  background-color: #fcfcfd;
}

.green-icon-pill {
  padding: 0.25rem; /* equivalent to p-1 in Tailwind */
  background-color: #ecfdf3; /* equivalent to bg-gray-200 in Tailwind */
  border-radius: 9999px; /* equivalent to rounded-full in Tailwind */
}

.green-pill-fg-text {
  color: #027a48;
  font-weight: 500;
  font-size: 14px;
}

.dashboard-title {
  font-size: 18px !important;
  font-weight: "medium" !important;
}

.dashboard-shadow {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.25s ease-in-out, transform 0.25s ease-in-out;
  border-radius: 8px;
}

.dashboard-shadow:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.light-purple-square-container {
  background-color: rgba(241, 235, 248, 0.97);
  width: 48px; /* or whatever size you want for the square */
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  overflow: hidden; /* to ensure the image also gets the corner radius */
}

.styled-image {
  max-width: 100%;
  height: auto;
  display: block; /* to remove any space below the image */
}

.MuiOutlinedInput-notchedOutline {
  border-radius: 8px !important;
}

.shine-button {
  position: relative;
  overflow: hidden;
  transform: translate3d(0, 0, 0); /* For better GPU performance */
}

.shine-button::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -70%;
  width: 200%;
  height: 200%;
  z-index: 1;
  opacity: 0;
  transform: rotate(30deg);
  pointer-events: none; /* Ensure the user can click the button and not the pseudo-element */
  background: linear-gradient(
    to right,
    transparent 10%,
    rgba(255, 255, 255, 0.9) 45%,
    transparent 90%
  );
  transition: all 0.6s ease-out;
}
.MuiButton-root:hover {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}

.shine-button:hover::after {
  opacity: 0.9; /* More pronounced shine */
  left: 120%; /* Move the shine effect farther to the right on hover */
  transition: all 0.6s ease-out;
}

.shine-button:active::after {
  opacity: 1; /* Maximum prominence on click */
  left: 120%; /* Move the shine effect farther to the right on click */
  transition: all 0.4s ease-out; /* Slightly faster transition for click */
}

.press-button {
  position: relative;
  background-color: #7f56d9; /* Change to desired button color */
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Initial shadow to give it a raised effect */
  text-align: center;
  outline: none;

}

.press-button:disabled,
.press-button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

.press-button:active {
  transform: translateY(4px); /* Pushes the button down */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Reduces the shadow to make it look pressed */
}

.press-button-border {
  position: relative;
  background-color: #7f56d9; /* Change to desired button color */
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Initial shadow to give it a raised effect */
  text-align: center;
  outline: none;
}

.press-button-border:disabled,
.press-button-border[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

.press-button-border:active {
  transform: translateY(4px); /* Pushes the button down */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Reduces the shadow to make it look pressed */
}

.customSelect .MuiOutlinedInput-root {
  border-radius: 1px !important;
}

.customSelect .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-radius: 1px !important;
}

.component-title {
  font-size: 14px !important;
  font-weight: "regular";
  color: #242810;
}

.divider-style {
  color: #e0e0e0;
  width: 60%;
}

.settings-text-field {
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 60%;
  padding: 10px;
  transition: border-color 0.3s, box-shadow 0.3s; /* Added box-shadow transition */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative; /* Added box-shadow */
}

.settings-text-field:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2); /* Added focus box-shadow */
}

.settings-text-field:hover::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 8px;
  border: 2px solid rgba(0, 123, 255, 0.5);
}

.settings-text-field::after {
  content: "Hint text";
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  color: #aaa;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.3s;
}

.settings-text-field::placeholder {
  font-size: 14px !important;
  color: #667085 !important;
  font-weight: 300;
  padding-right: 4px;
}
.settings-text-field:focus::after {
  opacity: 1;
}

.settings-text-field.valid {
  border-color: #28a745;
}

.settings-text-field.invalid {
  border-color: #dc3545;
}

.settings-text-field:invalid {
  outline: none;
  border-color: #dc3545;
}

.settings-text-field + .error-message {
  display: none;
  color: #dc3545;
  margin-top: 5px;
}

.settings-text-field:invalid + .error-message {
  display: block;
}

.settigs-grid-container {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  width: 100%;
  padding: 24px;
  margin-top: 32px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0); /* subtle shadow */
  transition: box-shadow 0.3s; /* transition for micro interaction */
}

.settigs-grid-container:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* amplified shadow on hover */
}

.settings-grid-item {
  margin-bottom: 10px;
  width: 100%;
}

.purple-radio {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #7f56d9;
  border-radius: 50%;
  background-color: rgba(28, 128, 0, 0);
  outline: none;
  cursor: pointer;
  margin-top: 16px;
  padding: 8px; /* Add padding to create a gap */
  box-sizing: border-box;
  transition: transform 0.2s; /* Add a transition effect for scaling */
  position: relative; /* Adding this to ensure pseudo-element is positioned relative to the input */
}

.purple-radio::before {
  content: "";
  display: block;
  position: absolute;
  top: -50%; /* Starting position of the shine effect */
  left: -50%;
  width: 200%; /* Width to cover the element and overflow */
  height: 200%; /* Height to cover the element and overflow */
  background: rgba(
    255,
    255,
    255,
    0.2
  ); /* Semi-transparent white to simulate shine */
  transform: rotate(-30deg) translate(-50%, -80%); /* Rotate and position the shine */
  transition: transform 0.7s ease; /* Smooth transition of shine moving */
  pointer-events: none; /* Ensures the shine doesn't interfere with clicks */
  opacity: 0; /* Hidden by default */
  z-index: 1; /* Make sure the shine is above the radio button */
}

.purple-radio:hover::before {
  transform: rotate(-30deg) translate(-50%, 200%); /* Move the shine downwards on hover */
  opacity: 1; /* Show the shine on hover */
}

.purple-radio::after {
  content: "";
  display: none; /* Hide the pseudo-element by default */
  width: 70%;
  height: 70%;
  background-color: #7f56d9;
  border-radius: 50%;
  box-sizing: border-box;
  margin: auto; /* Center the pseudo-element */
  margin-top: 0px;
  position: absolute; /* Use absolute positioning for the pseudo-element */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.3s, opacity 0.3s; /* Transition for scaling and fading in */
  transform: translate(-50%, -50%) scale(0); /* Start the inner circle as scaled down */
  opacity: 0; /* Start with the inner circle hidden */ /* Center the pseudo-element within the input */
}

.purple-radio:checked::after {
  display: block;
  transform: translate(-50%, -50%) scale(1); /* Scale the inner circle to its normal size */
  opacity: 1; /* Make the inner circle fully visible */ /* Show the pseudo-element when radio is checked */
}

.purple-radio:hover {
  transform: scale(1.1); /* Slightly scale up the radio button on hover */
  border-color: #6a29f4; /* Slightly different shade of purple on hover */
  background-color: rgba(155, 75, 209, 0.1);
  transform: translate(-5%, -5%) scale(1); /* Scale the inner circle to its normal size */
  opacity: 1; /* Slight purple tint as background */
}

.apexcharts-yaxis-label tspan, .apexcharts-xaxis-label tspan {
  fill: #717886;
  font-size: 12px;
  font-weight: 300;
  }

  .clamp-3-lines{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    -webkit-box-pack: end;
    padding-top: 1em;
  }
  .MuiClockNumber-root.Mui-selected {
    color: white !important;
  }

  .MuiPickersDay-root.Mui-selected {
    color: white !important;
  }
  .MuiIconButton-root.MuiClock-amButton {
    color: gray !important;
  }
  .MuiIconButton-root.MuiClock-pmButton {
    color: gray !important;
  }
  .ai-assesment .MuiFilledInput-root.Mui-disabled{
    background-color: #FFFBFF;
    color: black;
  }
  .ai-assesment .MuiFilledInput-input.Mui-disabled{
    color: black;
    -webkit-text-fill-color:black;
  }


  @keyframes shimmer {
    0% {
      background-position: -150%;
    }
    100% {
      background-position: 150%;
    }
  }

  .shine-effects::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(214, 32, 32, 0.8) 50%,
      transparent 100%
    );
    animation: shimmer 2s infinite;
  }

  .gradient-text {
    background: linear-gradient(90deg, #0b0b0c, #7F56D9, #0b0b0c);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

  .last\\:border-none:last-child {
  border-style: none;
}

  .hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.05rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .hover\\:-translate-y-0:hover {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .hover\\:cursor-pointer:hover {
  cursor: pointer;
}

  .hover\\:border-none:hover {
  border-style: none;
}

  .hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(127 86 217 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(97 97 97 / var(--tw-bg-opacity));
}

  .hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 118 210 / var(--tw-bg-opacity));
}

  .hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(56 142 60 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(66 66 66 / var(--tw-bg-opacity));
}

  .hover\\:bg-yellow-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 118 / var(--tw-bg-opacity));
}

  .hover\\:bg-base-purple:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 83 254 / var(--tw-bg-opacity));
}

  .hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 136 229 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

  .hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 41 47 / var(--tw-bg-opacity));
}

  .hover\\:bg-\\[\\#6142a6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(97 66 166 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}

  .hover\\:bg-\\[\\#f3efff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 239 255 / var(--tw-bg-opacity));
}

  .hover\\:bg-\\[\\#6B47E6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 71 230 / var(--tw-bg-opacity));
}

  .hover\\:bg-transparent:hover {
  background-color: transparent;
}

  .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

  .hover\\:bg-\\[\\#7042d3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(112 66 211 / var(--tw-bg-opacity));
}

  .hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

  .hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 154 154 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}

  .hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(189 189 189 / var(--tw-bg-opacity));
}

  .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

  .hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}

  .hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}

  .hover\\:text-\\[\\#7C53FE\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(124 83 254 / var(--tw-text-opacity));
}

  .hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(198 40 40 / var(--tw-text-opacity));
}

  .hover\\:underline:hover {
  text-decoration-line: underline;
}

  .hover\\:opacity-80:hover {
  opacity: 0.8;
}

  .hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .hover\\:shadow-\\[0_0_10px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.8\\)\\]:hover {
  --tw-shadow: 0 0 10px rgba(255,255,255,0.8);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .hover\\:ring-primary\\/50:hover {
  --tw-ring-color: rgb(127 86 217 / 0.5);
}

  .hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

  .hover\\:saturate-200:hover {
  --tw-saturate: saturate(2);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

  .focus\\:border-2:focus {
  border-width: 2px;
}

  .focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}

  .focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}

  .focus\\:border-base-purple:focus {
  --tw-border-opacity: 1;
  border-color: rgb(124 83 254 / var(--tw-border-opacity));
}

  .focus\\:bg-transparent:focus {
  background-color: transparent;
}

  .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

  .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

  .focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 150 243 / var(--tw-ring-opacity));
}

  .focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 81 181 / var(--tw-ring-opacity));
}

  .focus\\:ring-base-purple:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 83 254 / var(--tw-ring-opacity));
}

  .focus\\:ring-\\[\\#7C53FE\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 83 254 / var(--tw-ring-opacity));
}

  .focus\\:ring-gray-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(189 189 189 / var(--tw-ring-opacity));
}

  .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

  .active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .active\\:transform:active {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .active\\:shadow-inner:active {
  --tw-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  .group:hover .group-hover\\:bg-base-purple {
  --tw-bg-opacity: 1;
  background-color: rgb(124 83 254 / var(--tw-bg-opacity));
}

  .group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

  .group:hover .group-hover\\:text-primary {
  --tw-text-opacity: 1;
  color: rgb(127 86 217 / var(--tw-text-opacity));
}

  .group:hover .group-hover\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}

  .group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

  .group:hover .group-hover\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

  [dir="ltr"] .ltr\\:right-0 {
  right: 0px;
}

  [dir="ltr"] .ltr\\:ml-4 {
  margin-left: 0.4rem;
}

  [dir="ltr"] .ltr\\:ml-8 {
  margin-left: 0.8rem;
}

  [dir="ltr"] .ltr\\:border-r-1 {
  border-right-width: 1px;
}

  [dir="ltr"] .ltr\\:pr-48 {
  padding-right: 4.8rem;
}

  [dir="rtl"] .rtl\\:left-0 {
  left: 0px;
}

  [dir="rtl"] .rtl\\:mr-4 {
  margin-right: 0.4rem;
}

  [dir="rtl"] .rtl\\:mr-8 {
  margin-right: 0.8rem;
}

  [dir="rtl"] .rtl\\:border-l-1 {
  border-left-width: 1px;
}

  [dir="rtl"] .rtl\\:pl-48 {
  padding-left: 4.8rem;
}

  .dark .dark\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}

  @media (min-width: 600px) {

  .sm\\:order-last {
    order: 9999;
  }

  .sm\\:order-first {
    order: -9999;
  }

  .sm\\:m-24 {
    margin: 2.4rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-8 {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }

  .sm\\:mx-12 {
    margin-left: 1.2rem;
    margin-right: 1.2rem;
  }

  .sm\\:mt-32 {
    margin-top: 3.2rem;
  }

  .sm\\:mt-64 {
    margin-top: 6.4rem;
  }

  .sm\\:mb-16 {
    margin-bottom: 1.6rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mt-96 {
    margin-top: 9.6rem;
  }

  .sm\\:mt-16 {
    margin-top: 1.6rem;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-56 {
    height: 5.6rem;
  }

  .sm\\:min-h-auto {
    min-height: auto;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-320 {
    width: 32rem;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:rounded-2xl {
    border-radius: 1.6rem;
  }

  .sm\\:p-48 {
    padding: 4.8rem;
  }

  .sm\\:p-40 {
    padding: 4rem;
  }

  .sm\\:p-32 {
    padding: 3.2rem;
  }

  .sm\\:px-16 {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }

  .sm\\:px-12 {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }

  .sm\\:py-8 {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }

  .sm\\:text-20 {
    font-size: 2rem;
  }

  .sm\\:text-7xl {
    font-size: 4.8rem;
  }

  .sm\\:text-24 {
    font-size: 2.4rem;
  }

  .sm\\:text-3xl {
    font-size: 2.4rem;
  }

  .sm\\:text-base {
    font-size: 1.4rem;
  }

  .sm\\:shadow {
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

  @media (min-width: 960px) {

  .md\\:mx-4 {
    margin-left: 0.4rem;
    margin-right: 0.4rem;
  }

  .md\\:mb-68 {
    margin-bottom: 6.8rem;
  }

  .md\\:mt-\\[-32px\\] {
    margin-top: -32px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:h-48 {
    height: 4.8rem;
  }

  .md\\:h-64 {
    height: 6.4rem;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:h-72 {
    height: 7.2rem;
  }

  .md\\:min-h-64 {
    min-height: 6.4rem;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .md\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .md\\:w-\\[67\\%\\] {
    width: 67%;
  }

  .md\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:rounded-none {
    border-radius: 0px;
  }

  .md\\:p-64 {
    padding: 6.4rem;
  }

  .md\\:p-32 {
    padding: 3.2rem;
  }

  .md\\:px-16 {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }

  .md\\:py-6 {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }

  .md\\:px-8 {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }

  .md\\:px-32 {
    padding-left: 3.2rem;
    padding-right: 3.2rem;
  }

  .md\\:px-28 {
    padding-left: 2.8rem;
    padding-right: 2.8rem;
  }

  .md\\:py-24 {
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
  }

  .md\\:px-12 {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pr-24 {
    padding-right: 2.4rem;
  }

  .md\\:text-7xl {
    font-size: 4.8rem;
  }

  .md\\:text-xl {
    font-size: 1.8rem;
  }

  .md\\:text-32 {
    font-size: 3.2rem;
  }

  .md\\:leading-none {
    line-height: 1;
  }

  .md\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

  @media (min-width: 1280px) {

  .lg\\:mr-80 {
    margin-right: 8rem;
  }

  .lg\\:mt-\\[-32px\\] {
    margin-top: -32px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .lg\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .lg\\:w-\\[67\\%\\] {
    width: 67%;
  }

  .lg\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:px-112 {
    padding-left: 11.2rem;
    padding-right: 11.2rem;
  }

  .lg\\:px-48 {
    padding-left: 4.8rem;
    padding-right: 4.8rem;
  }
}

  @media (min-width: 1920px) {

  .xl\\:mt-\\[-32px\\] {
    margin-top: -32px;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:h-screen {
    height: 100vh;
  }

  .xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .xl\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .xl\\:w-\\[67\\%\\] {
    width: 67%;
  }

  .xl\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:px-64 {
    padding-left: 6.4rem;
    padding-right: 6.4rem;
  }

  .xl\\:pr-24 {
    padding-right: 2.4rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;AACd;EAAA,WAAA;AAAoB;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB,eAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,SAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;;EAAA;IAAA,4BAAA;EAAmB;;EAAnB;IAAA,2BAAA;EAAmB;AAAA;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oEAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qEAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,qCAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oCAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,sCAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+GAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,2FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,0HAAmB;EAAnB,4IAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,mGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,yHAAmB;EAAnB,2IAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,kFAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB,qGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,qCAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,iLAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB,qBAAA;AAAmB;;AAEnB,4CAA4C;AAC5C;EACE,6DAA6D;AAC/D;;AAEA;;EAEE;;AAEF;EACE,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;EACvC,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB;;;;GAIC;EACD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAK7B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,cAAc;AAVhB;;AAaA;EACE,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,WAAW;IACX,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;;;;EAIE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB,EAAE,kCAAkC;EACpD,yBAAyB,EAAE,0CAA0C;EACrE,qBAAqB,EAAE,2CAA2C;AACpE;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,WAAW,EAAE,6CAA6C;EAC1D,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B,EAAE,+BAA+B;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,oBAAoB,EAAE,oEAAoE;EAC1F;;;;;GAKC;EACD,6BAA6B;AAC/B;AACA;EACE;6EAC2E;AAC7E;;AAEA;EACE,YAAY,EAAE,0BAA0B;EACxC,UAAU,EAAE,wDAAwD;EACpE,6BAA6B;AAC/B;;AAEA;EACE,UAAU,EAAE,gCAAgC;EAC5C,UAAU,EAAE,wDAAwD;EACpE,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,yCAAyC,EAAE,8CAA8C;EACzF,kBAAkB;EAClB,aAAa;;AAEf;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B,EAAE,2BAA2B;EACvD,wCAAwC,EAAE,+CAA+C;AAC3F;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,mCAAmC;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,yCAAyC,EAAE,8CAA8C;EACzF,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B,EAAE,2BAA2B;EACvD,wCAAwC,EAAE,+CAA+C;AAC3F;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8CAA8C,EAAE,gCAAgC;EAChF,wCAAwC;EACxC,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C,EAAE,2BAA2B;AAC3E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC,EAAE,kBAAkB;EACxD,2BAA2B,EAAE,qCAAqC;AACpE;;AAEA;EACE,uCAAuC,EAAE,8BAA8B;AACzE;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY,EAAE,gCAAgC;EAC9C,sBAAsB;EAEtB,0BAA0B,EAAE,wCAAwC;EACpE,kBAAkB,EAAE,6EAA6E;AACnG;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS,EAAE,0CAA0C;EACrD,UAAU;EACV,WAAW,EAAE,4CAA4C;EACzD,YAAY,EAAE,6CAA6C;EAC3D;;;;;GAKC,EAAE,6CAA6C;EAChD,+CAA+C,EAAE,kCAAkC;EACnF,+BAA+B,EAAE,sCAAsC;EACvE,oBAAoB,EAAE,oDAAoD;EAC1E,UAAU,EAAE,sBAAsB;EAClC,UAAU,EAAE,kDAAkD;AAChE;;AAEA;EACE,+CAA+C,EAAE,sCAAsC;EACvF,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,uCAAuC;EACtD,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAE,8BAA8B;EAC5C,eAAe;EACf,kBAAkB,EAAE,oDAAoD;EACxE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC,EAAE,yCAAyC;EACnF,yCAAyC,EAAE,0CAA0C;EACrF,UAAU,EAAE,uCAAuC,EAAE,+CAA+C;AACtG;;AAEA;EACE,cAAc;EACd,yCAAyC,EAAE,8CAA8C;EACzF,UAAU,EAAE,wCAAwC,EAAE,kDAAkD;AAC1G;;AAEA;EACE,qBAAqB,EAAE,gDAAgD;EACvE,qBAAqB,EAAE,gDAAgD;EACvE,yCAAyC;EACzC,uCAAuC,EAAE,8CAA8C;EACvF,UAAU,EAAE,qCAAqC;AACnD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;;EAGA;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;;;;KAKC;IACD,8BAA8B;EAChC;;EAEA;IACE,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;EACvB;;EA5nBF;EAAA,wBAAA;AAu9GA;;EAv9GA;EAAA,kBAAA;AA29GA;;EA39GA;EAAA,0BAAA;EAAA,+LAAA;AAg+GA;;EAh+GA;EAAA,sBAAA;EAAA,+LAAA;AAq+GA;;EAr+GA;EAAA,iBAAA;EAAA,iBAAA;EAAA,+LAAA;AA2+GA;;EA3+GA;EAAA,eAAA;AA++GA;;EA/+GA;EAAA,kBAAA;AAm/GA;;EAn/GA;EAAA,kBAAA;EAAA,wDAAA;AAw/GA;;EAx/GA;EAAA,kBAAA;EAAA,sDAAA;AA6/GA;;EA7/GA;EAAA,kBAAA;EAAA,wDAAA;AAkgHA;;EAlgHA;EAAA,kBAAA;EAAA,uDAAA;AAugHA;;EAvgHA;EAAA,kBAAA;EAAA,sDAAA;AA4gHA;;EA5gHA;EAAA,kBAAA;EAAA,yDAAA;AAihHA;;EAjhHA;EAAA,kBAAA;EAAA,wDAAA;AAshHA;;EAthHA;EAAA,kBAAA;EAAA,wDAAA;AA2hHA;;EA3hHA;EAAA,kBAAA;EAAA,yDAAA;AAgiHA;;EAhiHA;EAAA,kBAAA;EAAA,sDAAA;AAqiHA;;EAriHA;EAAA,kBAAA;EAAA,uDAAA;AA0iHA;;EA1iHA;EAAA,kBAAA;EAAA,yDAAA;AA+iHA;;EA/iHA;EAAA,kBAAA;EAAA,yDAAA;AAojHA;;EApjHA;EAAA,kBAAA;EAAA,wDAAA;AAyjHA;;EAzjHA;EAAA,6BAAA;AA6jHA;;EA7jHA;EAAA,kBAAA;EAAA,yDAAA;AAkkHA;;EAlkHA;EAAA,kBAAA;EAAA,wDAAA;AAukHA;;EAvkHA;EAAA,kBAAA;EAAA,yDAAA;AA4kHA;;EA5kHA;EAAA,kBAAA;EAAA,yDAAA;AAilHA;;EAjlHA;EAAA,kBAAA;EAAA,yDAAA;AAslHA;;EAtlHA;EAAA,kBAAA;EAAA,yDAAA;AA2lHA;;EA3lHA;EAAA,oBAAA;EAAA,gDAAA;AAgmHA;;EAhmHA;EAAA,oBAAA;EAAA,8CAAA;AAqmHA;;EArmHA;EAAA,oBAAA;EAAA,6CAAA;AA0mHA;;EA1mHA;EAAA,oBAAA;EAAA,+CAAA;AA+mHA;;EA/mHA;EAAA,oBAAA;EAAA,8CAAA;AAonHA;;EApnHA;EAAA,+BAAA;AAwnHA;;EAxnHA;EAAA,YAAA;AA4nHA;;EA5nHA;EAAA,kFAAA;EAAA,iGAAA;EAAA,uGAAA;AAkoHA;;EAloHA;EAAA,oFAAA;EAAA,mGAAA;EAAA,uGAAA;AAwoHA;;EAxoHA;EAAA,2CAAA;EAAA,oDAAA;EAAA,uGAAA;AA8oHA;;EA9oHA;EAAA,sFAAA;EAAA,qGAAA;EAAA,uGAAA;AAopHA;;EAppHA;EAAA,kDAAA;EAAA,6DAAA;EAAA,uGAAA;AA0pHA;;EA1pHA;EAAA,sCAAA;AA8pHA;;EA9pHA;EAAA,gCAAA;EAAA,iLAAA;AAmqHA;;EAnqHA;EAAA,0BAAA;EAAA,iLAAA;AAwqHA;;EAxqHA;EAAA,iBAAA;AA4qHA;;EA5qHA;EAAA,sBAAA;EAAA,wDAAA;AAirHA;;EAjrHA;EAAA,sBAAA;EAAA,uDAAA;AAsrHA;;EAtrHA;EAAA,sBAAA;EAAA,wDAAA;AA2rHA;;EA3rHA;EAAA,6BAAA;AA+rHA;;EA/rHA;EAAA,8BAAA;EAAA,mBAAA;AAosHA;;EApsHA;EAAA,2GAAA;EAAA,yGAAA;EAAA,4FAAA;AA0sHA;;EA1sHA;EAAA,oBAAA;EAAA,yDAAA;AA+sHA;;EA/sHA;EAAA,oBAAA;EAAA,wDAAA;AAotHA;;EAptHA;EAAA,oBAAA;EAAA,yDAAA;AAytHA;;EAztHA;EAAA,oBAAA;EAAA,yDAAA;AA8tHA;;EA9tHA;EAAA,oBAAA;EAAA,0DAAA;AAmuHA;;EAnuHA;EAAA,2BAAA;AAuuHA;;EAvuHA;EAAA,iBAAA;EAAA,iBAAA;EAAA,+LAAA;AA6uHA;;EA7uHA;EAAA,+LAAA;AAivHA;;EAjvHA;EAAA,+CAAA;EAAA,6DAAA;EAAA,uGAAA;AAuvHA;;EAvvHA;EAAA,kBAAA;EAAA,wDAAA;AA4vHA;;EA5vHA;EAAA,oBAAA;EAAA,gDAAA;AAiwHA;;EAjwHA;EAAA,oBAAA;EAAA,+CAAA;AAswHA;;EAtwHA;EAAA,oBAAA;EAAA,6CAAA;AA2wHA;;EA3wHA;EAAA,UAAA;AA+wHA;;EA/wHA;EAAA,oFAAA;EAAA,mGAAA;EAAA,uGAAA;AAqxHA;;EArxHA;EAAA,UAAA;AAyxHA;;EAzxHA;EAAA,mBAAA;AA6xHA;;EA7xHA;EAAA,mBAAA;AAiyHA;;EAjyHA;EAAA,uBAAA;AAqyHA;;EAryHA;EAAA,qBAAA;AAyyHA;;EAzyHA;EAAA,SAAA;AA6yHA;;EA7yHA;EAAA,oBAAA;AAizHA;;EAjzHA;EAAA,oBAAA;AAqzHA;;EArzHA;EAAA,sBAAA;AAyzHA;;EAzzHA;EAAA,oBAAA;AA6zHA;;EA7zHA;EAAA,oBAAA;EAAA,gDAAA;AAk0HA;;EAl0HA;;EAAA;IAAA,WAAA;EAw0HE;;EAx0HF;IAAA,YAAA;EA40HE;;EA50HF;IAAA,cAAA;EAg1HE;;EAh1HF;IAAA,gBAAA;IAAA,iBAAA;EAq1HE;;EAr1HF;IAAA,mBAAA;IAAA,oBAAA;EA01HE;;EA11HF;IAAA,mBAAA;IAAA,oBAAA;EA+1HE;;EA/1HF;IAAA,kBAAA;EAm2HE;;EAn2HF;IAAA,kBAAA;EAu2HE;;EAv2HF;IAAA,qBAAA;EA22HE;;EA32HF;IAAA,kBAAA;EA+2HE;;EA/2HF;IAAA,kBAAA;EAm3HE;;EAn3HF;IAAA,kBAAA;EAu3HE;;EAv3HF;IAAA,YAAA;EA23HE;;EA33HF;IAAA,cAAA;EA+3HE;;EA/3HF;IAAA,gBAAA;EAm4HE;;EAn4HF;IAAA,WAAA;EAu4HE;;EAv4HF;IAAA,YAAA;EA24HE;;EA34HF;IAAA,UAAA;EA+4HE;;EA/4HF;IAAA,gDAAA;EAm5HE;;EAn5HF;IAAA,mBAAA;EAu5HE;;EAv5HF;IAAA,sBAAA;EA25HE;;EA35HF;IAAA,uBAAA;EA+5HE;;EA/5HF;IAAA,mBAAA;EAm6HE;;EAn6HF;IAAA,uBAAA;EAu6HE;;EAv6HF;IAAA,8BAAA;EA26HE;;EA36HF;IAAA,qBAAA;EA+6HE;;EA/6HF;IAAA,eAAA;EAm7HE;;EAn7HF;IAAA,aAAA;EAu7HE;;EAv7HF;IAAA,eAAA;EA27HE;;EA37HF;IAAA,oBAAA;IAAA,qBAAA;EAg8HE;;EAh8HF;IAAA,oBAAA;IAAA,qBAAA;EAq8HE;;EAr8HF;IAAA,mBAAA;IAAA,sBAAA;EA08HE;;EA18HF;IAAA,eAAA;EA88HE;;EA98HF;IAAA,iBAAA;EAk9HE;;EAl9HF;IAAA,iBAAA;EAs9HE;;EAt9HF;IAAA,iBAAA;EA09HE;;EA19HF;IAAA,iBAAA;EA89HE;;EA99HF;IAAA,4EAAA;IAAA,2FAAA;IAAA,uGAAA;EAo+HE;AACF;;EAr+HA;;EAAA;IAAA,mBAAA;IAAA,oBAAA;EA4+HE;;EA5+HF;IAAA,qBAAA;EAg/HE;;EAh/HF;IAAA,iBAAA;EAo/HE;;EAp/HF;IAAA,eAAA;EAw/HE;;EAx/HF;IAAA,cAAA;EA4/HE;;EA5/HF;IAAA,aAAA;EAggIE;;EAhgIF;IAAA,cAAA;EAogIE;;EApgIF;IAAA,cAAA;EAwgIE;;EAxgIF;IAAA,YAAA;EA4gIE;;EA5gIF;IAAA,cAAA;EAghIE;;EAhhIF;IAAA,kBAAA;EAohIE;;EAphIF;IAAA,UAAA;EAwhIE;;EAxhIF;IAAA,UAAA;EA4hIE;;EA5hIF;IAAA,UAAA;EAgiIE;;EAhiIF;IAAA,UAAA;EAoiIE;;EApiIF;IAAA,UAAA;EAwiIE;;EAxiIF;IAAA,gDAAA;EA4iIE;;EA5iIF;IAAA,gDAAA;EAgjIE;;EAhjIF;IAAA,mBAAA;EAojIE;;EApjIF;IAAA,uBAAA;EAwjIE;;EAxjIF;IAAA,mBAAA;EA4jIE;;EA5jIF;IAAA,2BAAA;EAgkIE;;EAhkIF;IAAA,yBAAA;EAokIE;;EApkIF;IAAA,kBAAA;EAwkIE;;EAxkIF;IAAA,eAAA;EA4kIE;;EA5kIF;IAAA,eAAA;EAglIE;;EAhlIF;IAAA,oBAAA;IAAA,qBAAA;EAqlIE;;EArlIF;IAAA,mBAAA;IAAA,sBAAA;EA0lIE;;EA1lIF;IAAA,oBAAA;IAAA,qBAAA;EA+lIE;;EA/lIF;IAAA,oBAAA;IAAA,qBAAA;EAomIE;;EApmIF;IAAA,oBAAA;IAAA,qBAAA;EAymIE;;EAzmIF;IAAA,mBAAA;IAAA,sBAAA;EA8mIE;;EA9mIF;IAAA,oBAAA;IAAA,qBAAA;EAmnIE;;EAnnIF;IAAA,mBAAA;EAunIE;;EAvnIF;IAAA,qBAAA;EA2nIE;;EA3nIF;IAAA,iBAAA;EA+nIE;;EA/nIF;IAAA,iBAAA;EAmoIE;;EAnoIF;IAAA,iBAAA;EAuoIE;;EAvoIF;IAAA,cAAA;EA2oIE;;EA3oIF;IAAA,sBAAA;IAAA,8BAAA;IAAA,uGAAA;EAipIE;AACF;;EAlpIA;;EAAA;IAAA,kBAAA;EAwpIE;;EAxpIF;IAAA,iBAAA;EA4pIE;;EA5pIF;IAAA,eAAA;EAgqIE;;EAhqIF;IAAA,aAAA;EAoqIE;;EApqIF;IAAA,UAAA;EAwqIE;;EAxqIF;IAAA,UAAA;EA4qIE;;EA5qIF;IAAA,UAAA;EAgrIE;;EAhrIF;IAAA,UAAA;EAorIE;;EAprIF;IAAA,iBAAA;EAwrIE;;EAxrIF;IAAA,gDAAA;EA4rIE;;EA5rIF;IAAA,mBAAA;EAgsIE;;EAhsIF;IAAA,qBAAA;IAAA,sBAAA;EAqsIE;;EArsIF;IAAA,oBAAA;IAAA,qBAAA;EA0sIE;AACF;;EA3sIA;;EAAA;IAAA,iBAAA;EAitIE;;EAjtIF;IAAA,eAAA;EAqtIE;;EArtIF;IAAA,aAAA;EAytIE;;EAztIF;IAAA,UAAA;EA6tIE;;EA7tIF;IAAA,UAAA;EAiuIE;;EAjuIF;IAAA,UAAA;EAquIE;;EAruIF;IAAA,UAAA;EAyuIE;;EAzuIF;IAAA,gDAAA;EA6uIE;;EA7uIF;IAAA,mBAAA;EAivIE;;EAjvIF;IAAA,oBAAA;IAAA,qBAAA;EAsvIE;;EAtvIF;IAAA,qBAAA;EA0vIE;AACF","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Force Inter + Helvetica font everywhere */\nhtml, body, * {\n  font-family: \"Inter\", Helvetica, Arial, sans-serif !important;\n}\n\n/**\n * Custom base styles\n */\n\n* {\n  /* Text rendering */\n  text-rendering: optimizeLegibility;\n  -o-text-rendering: optimizeLegibility;\n  -ms-text-rendering: optimizeLegibility;\n  -moz-text-rendering: optimizeLegibility;\n  -webkit-text-rendering: optimizeLegibility;\n  -webkit-tap-highlight-color: transparent;\n}\n\n* :focus {\n  outline: none !important;\n}\n\n\n\nhtml {\n  font-size: 62.5%;\n  font-family: \"Inter var\";\n  background-color: #121212;\n}\n\nbody {\n  font-size: 14px;\n  line-height: 1.4;\n  overflow-x: hidden;\n  font-feature-settings: \"salt\";\n  font-family: \"Inter var\";\n}\n\n.logo-heading {\n  font-size: 18px;\n  margin-left: 10px;\n  font-weight: 600;\n  background: -webkit-linear-gradient(\n    168.48deg,\n    #713ac3 -2.01%,\n    #1aa4cf 104.47%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\nhtml,\nbody {\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n\nhtml,\nbody {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 0;\n  min-height: 100%;\n  width: 100%;\n  flex: 1 1 auto;\n}\n\n.FusePageSimple-contentWrapper {\n  background-color: white; /* Body content change */\n}\n\n#root {\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n}\n\nh1,\n.h1 {\n  font-size: 24px;\n}\n\nh2,\n.h2 {\n  font-size: 20px;\n}\n\nh3,\n.h3 {\n  font-size: 16px;\n}\n\nh4,\n.h4 {\n  font-size: 15px;\n}\n\nh5,\n.h5 {\n  font-size: 13px;\n}\n\nh6,\n.h6 {\n  font-size: 12px;\n}\n\n.ps > .ps__rail-y,\n.ps > .ps__rail-x {\n  z-index: 99;\n}\n\na[role=\"button\"] {\n  text-decoration: none;\n}\n\n[role=\"tooltip\"] {\n  z-index: 9999;\n}\n\n.MuiModal-root {\n  z-index: 9999;\n}\n\n/* Medium Devices, Desktops Only */\n@media only screen and (min-width: 992px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  ::-webkit-scrollbar:hover {\n    width: 8px;\n    height: 8px;\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border: 2px solid transparent;\n    border-radius: 20px;\n  }\n\n  ::-webkit-scrollbar-thumb:active {\n    border-radius: 20px;\n  }\n}\n\nform label {\n  z-index: 99;\n}\n\nbody.no-animate *,\nbody.no-animate *::before,\nbody.no-animate *::after {\n  transition: none !important;\n  animation: none !important;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n/* Removes webkit's autofill backgorund color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transitiondelay: 9999s;\n  transitionproperty: background-color, color;\n}\n\n:focus {\n  outline-color: transparent;\n}\n\n/*fullcalendar Fix*/\n.fc-scrollgrid-section-liquid {\n  height: 1px !important;\n}\n\n.widget-title {\n  font-size: 22px !important;\n  font-weight: \"medium\";\n  color: #242810;\n}\n\n.widget-label-tiny {\n  font-size: 10px;\n  font-weight: \"medium\";\n  color: #667085;\n}\n\n.widget-label-small {\n  font-size: 12px;\n  font-weight: \"regular\";\n  color: #667085;\n}\n\n.widget-label-regular {\n  font-size: 14px;\n  font-weight: \"regular\";\n  color: #667085;\n}\n\n.widget-label-large {\n  font-size: 20px;\n  font-weight: 500 !important;\n  color: #101828;\n}\n\n.widget-label-medium {\n  font-size: 18px;\n  font-weight: 500 !important;\n  color: #101828;\n}\n\n.page-heading {\n  font-size: 24px;\n  font-weight: \"medium\";\n  color: #101828;\n}\n\n.page-background {\n  background-color: #fcfcfd;\n}\n\n.green-icon-pill {\n  padding: 0.25rem; /* equivalent to p-1 in Tailwind */\n  background-color: #ecfdf3; /* equivalent to bg-gray-200 in Tailwind */\n  border-radius: 9999px; /* equivalent to rounded-full in Tailwind */\n}\n\n.green-pill-fg-text {\n  color: #027a48;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.dashboard-title {\n  font-size: 18px !important;\n  font-weight: \"medium\" !important;\n}\n\n.dashboard-shadow {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.25s ease-in-out, transform 0.25s ease-in-out;\n  border-radius: 8px;\n}\n\n.dashboard-shadow:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.light-purple-square-container {\n  background-color: rgba(241, 235, 248, 0.97);\n  width: 48px; /* or whatever size you want for the square */\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  overflow: hidden; /* to ensure the image also gets the corner radius */\n}\n\n.styled-image {\n  max-width: 100%;\n  height: auto;\n  display: block; /* to remove any space below the image */\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-radius: 8px !important;\n}\n\n.shine-button {\n  position: relative;\n  overflow: hidden;\n  transform: translate3d(0, 0, 0); /* For better GPU performance */\n}\n\n.shine-button::after {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -70%;\n  width: 200%;\n  height: 200%;\n  z-index: 1;\n  opacity: 0;\n  transform: rotate(30deg);\n  pointer-events: none; /* Ensure the user can click the button and not the pseudo-element */\n  background: linear-gradient(\n    to right,\n    transparent 10%,\n    rgba(255, 255, 255, 0.9) 45%,\n    transparent 90%\n  );\n  transition: all 0.6s ease-out;\n}\n.MuiButton-root:hover {\n  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),\n    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);\n}\n\n.shine-button:hover::after {\n  opacity: 0.9; /* More pronounced shine */\n  left: 120%; /* Move the shine effect farther to the right on hover */\n  transition: all 0.6s ease-out;\n}\n\n.shine-button:active::after {\n  opacity: 1; /* Maximum prominence on click */\n  left: 120%; /* Move the shine effect farther to the right on click */\n  transition: all 0.4s ease-out; /* Slightly faster transition for click */\n}\n\n.press-button {\n  position: relative;\n  background-color: #7f56d9; /* Change to desired button color */\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  color: white;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Initial shadow to give it a raised effect */\n  text-align: center;\n  outline: none;\n\n}\n\n.press-button:disabled,\n.press-button[disabled] {\n  border: 1px solid #999999;\n  background-color: #cccccc;\n  color: #666666;\n}\n\n.press-button:active {\n  transform: translateY(4px); /* Pushes the button down */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Reduces the shadow to make it look pressed */\n}\n\n.press-button-border {\n  position: relative;\n  background-color: #7f56d9; /* Change to desired button color */\n  padding: 10px 20px;\n  border-radius: 5px;\n  color: white;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Initial shadow to give it a raised effect */\n  text-align: center;\n  outline: none;\n}\n\n.press-button-border:disabled,\n.press-button-border[disabled] {\n  border: 1px solid #999999;\n  background-color: #cccccc;\n  color: #666666;\n}\n\n.press-button-border:active {\n  transform: translateY(4px); /* Pushes the button down */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Reduces the shadow to make it look pressed */\n}\n\n.customSelect .MuiOutlinedInput-root {\n  border-radius: 1px !important;\n}\n\n.customSelect .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-radius: 1px !important;\n}\n\n.component-title {\n  font-size: 14px !important;\n  font-weight: \"regular\";\n  color: #242810;\n}\n\n.divider-style {\n  color: #e0e0e0;\n  width: 60%;\n}\n\n.settings-text-field {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  width: 60%;\n  padding: 10px;\n  transition: border-color 0.3s, box-shadow 0.3s; /* Added box-shadow transition */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative; /* Added box-shadow */\n}\n\n.settings-text-field:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2); /* Added focus box-shadow */\n}\n\n.settings-text-field:hover::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 8px;\n  border: 2px solid rgba(0, 123, 255, 0.5);\n}\n\n.settings-text-field::after {\n  content: \"Hint text\";\n  position: absolute;\n  top: calc(100% + 5px);\n  left: 0;\n  color: #aaa;\n  font-size: 12px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.settings-text-field::placeholder {\n  font-size: 14px !important;\n  color: #667085 !important;\n  font-weight: 300;\n  padding-right: 4px;\n}\n.settings-text-field:focus::after {\n  opacity: 1;\n}\n\n.settings-text-field.valid {\n  border-color: #28a745;\n}\n\n.settings-text-field.invalid {\n  border-color: #dc3545;\n}\n\n.settings-text-field:invalid {\n  outline: none;\n  border-color: #dc3545;\n}\n\n.settings-text-field + .error-message {\n  display: none;\n  color: #dc3545;\n  margin-top: 5px;\n}\n\n.settings-text-field:invalid + .error-message {\n  display: block;\n}\n\n.settigs-grid-container {\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  text-align: left;\n  width: 100%;\n  padding: 24px;\n  margin-top: 32px;\n  border-radius: 8px;\n  border: solid 1px #e0e0e0;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0); /* subtle shadow */\n  transition: box-shadow 0.3s; /* transition for micro interaction */\n}\n\n.settigs-grid-container:hover {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* amplified shadow on hover */\n}\n\n.settings-grid-item {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.purple-radio {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #7f56d9;\n  border-radius: 50%;\n  background-color: rgba(28, 128, 0, 0);\n  outline: none;\n  cursor: pointer;\n  margin-top: 16px;\n  padding: 8px; /* Add padding to create a gap */\n  box-sizing: border-box;\n  position: relative;\n  transition: transform 0.2s; /* Add a transition effect for scaling */\n  position: relative; /* Adding this to ensure pseudo-element is positioned relative to the input */\n}\n\n.purple-radio::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -50%; /* Starting position of the shine effect */\n  left: -50%;\n  width: 200%; /* Width to cover the element and overflow */\n  height: 200%; /* Height to cover the element and overflow */\n  background: rgba(\n    255,\n    255,\n    255,\n    0.2\n  ); /* Semi-transparent white to simulate shine */\n  transform: rotate(-30deg) translate(-50%, -80%); /* Rotate and position the shine */\n  transition: transform 0.7s ease; /* Smooth transition of shine moving */\n  pointer-events: none; /* Ensures the shine doesn't interfere with clicks */\n  opacity: 0; /* Hidden by default */\n  z-index: 1; /* Make sure the shine is above the radio button */\n}\n\n.purple-radio:hover::before {\n  transform: rotate(-30deg) translate(-50%, 200%); /* Move the shine downwards on hover */\n  opacity: 1; /* Show the shine on hover */\n}\n\n.purple-radio::after {\n  content: \"\";\n  display: none; /* Hide the pseudo-element by default */\n  width: 70%;\n  height: 70%;\n  background-color: #7f56d9;\n  border-radius: 50%;\n  box-sizing: border-box;\n  margin: auto; /* Center the pseudo-element */\n  margin-top: 0px;\n  position: absolute; /* Use absolute positioning for the pseudo-element */\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: transform 0.3s, opacity 0.3s; /* Transition for scaling and fading in */\n  transform: translate(-50%, -50%) scale(0); /* Start the inner circle as scaled down */\n  opacity: 0; /* Start with the inner circle hidden */ /* Center the pseudo-element within the input */\n}\n\n.purple-radio:checked::after {\n  display: block;\n  transform: translate(-50%, -50%) scale(1); /* Scale the inner circle to its normal size */\n  opacity: 1; /* Make the inner circle fully visible */ /* Show the pseudo-element when radio is checked */\n}\n\n.purple-radio:hover {\n  transform: scale(1.1); /* Slightly scale up the radio button on hover */\n  border-color: #6a29f4; /* Slightly different shade of purple on hover */\n  background-color: rgba(155, 75, 209, 0.1);\n  transform: translate(-5%, -5%) scale(1); /* Scale the inner circle to its normal size */\n  opacity: 1; /* Slight purple tint as background */\n}\n\n.apexcharts-yaxis-label tspan, .apexcharts-xaxis-label tspan {\n  fill: #717886;\n  font-size: 12px;\n  font-weight: 300;\n  }\n\n  .clamp-3-lines{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3;\n    -webkit-box-pack: end;\n    padding-top: 1em;\n  }\n  .MuiClockNumber-root.Mui-selected {\n    color: white !important;\n  }\n\n  .MuiPickersDay-root.Mui-selected {\n    color: white !important;\n  }\n  .MuiIconButton-root.MuiClock-amButton {\n    color: gray !important;\n  }\n  .MuiIconButton-root.MuiClock-pmButton {\n    color: gray !important;\n  }\n  .ai-assesment .MuiFilledInput-root.Mui-disabled{\n    background-color: #FFFBFF;\n    color: black;\n  }\n  .ai-assesment .MuiFilledInput-input.Mui-disabled{\n    color: black;\n    -webkit-text-fill-color:black;\n  }\n\n\n  @keyframes shimmer {\n    0% {\n      background-position: -150%;\n    }\n    100% {\n      background-position: 150%;\n    }\n  }\n\n  .shine-effects::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      to right,\n      transparent 0%,\n      rgba(214, 32, 32, 0.8) 50%,\n      transparent 100%\n    );\n    animation: shimmer 2s infinite;\n  }\n\n  .gradient-text {\n    background: linear-gradient(90deg, #0b0b0c, #7F56D9, #0b0b0c);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
